import { useTranslation } from 'react-i18next';
import { ImageComponent } from '@/components/Image';
import { CardAnimation } from '../assets/CardAnimation';
import {
  ScCardWrapper,
  ScIntroBg,
  ScIntroSection,
  ScIntroWrapper,
} from './styled';

export const IntroSection = () => {
  const { t } = useTranslation('vip');
  return (
    <ScIntroWrapper>
      <ScIntroBg>
        <ImageComponent alt="intro-bg" fill src="/vip/intro-bg.webp" />
      </ScIntroBg>
      <ScIntroSection>
        <div className="text-wrapper">
          <span className="title">{t('intro.title')}</span>
          <span className="description">{t('intro.description')}</span>
        </div>
        <ScCardWrapper>
          <CardAnimation className="card-anim-bg" />
          <ImageComponent
            alt="intro-card"
            className="intro-img"
            height={231}
            src="/vip/intro-card.webp"
            width={453}
          />
        </ScCardWrapper>
      </ScIntroSection>
    </ScIntroWrapper>
  );
};
